import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './AIChatPlaygroundImageMessagePart.scss';
import { ImageMessagePart } from '../../../aIChatPlaygroundInterface';

interface IAIChatPlaygroundImageMessagePartProps {
	content: ImageMessagePart['content'],
}

export const AIChatPlaygroundImageMessagePart = ({ content }: IAIChatPlaygroundImageMessagePartProps) => {
	useStyles(s);

	return (
		<div className="ai-chat-playground-image-message-part">
			<img src={content.url} />
		</div>
	);
};
